import request from 'request';
import { HierarchyEntityResource } from 'services/resources';

const BASE_URL = 'common/hierarchy/';

const URLs = {
  hierarchyEntities: BASE_URL,
} as const;

/**
 * Returns a list of data sources
 */
function getHierarchyEntities() {
  return request<HierarchyEntityResource[]>(URLs.hierarchyEntities, {
    method: 'GET',
  });
}

export default getHierarchyEntities;
